import React, { useEffect } from 'react'
import Placements from '../components/PlacementsPage/Placements'

const PlacementPage = () => {

  useEffect(() => {
          window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Placements />
    </div>
  )
}

export default PlacementPage